import { combineReducers } from "redux";
import { homeSlice } from "../module/home/redux/HomeSlice";
import { masterLayoutSlice } from "../module/common/redux/MasterLayoutSlice";

export const rootReducer = combineReducers({
  // get from slice file
  masterLayout: masterLayoutSlice.reducer,
  home: homeSlice.reducer,
});
